module.exports = __webpack_public_path__ + "img/SM.dd809abc.png";